import { render, staticRenderFns } from "./NewCustomer.vue?vue&type=template&id=f47b3d16&scoped=true&"
import script from "./NewCustomer.ts?vue&type=script&lang=ts&"
export * from "./NewCustomer.ts?vue&type=script&lang=ts&"
import style0 from "./NewCustomer.less?vue&type=style&index=0&id=f47b3d16&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47b3d16",
  null
  
)

export default component.exports